<template>
  <div class="app-container">
    <slot name="top" />
    <el-upload
      class="upload-demo-20210810"
      drag
      action=""
      :on-change="handleChange"
      :http-request="httpRequest"
      :before-upload="bjBeforeUpload"
      :multiple="false"
      :file-list="fileList"
      :accept="accept"
    >
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">{{ $t('UploadMainText1') }}<em>{{ $t('UploadMainText2') }}</em></div>
      <div slot="tip" class="el-upload__tip">
        <slot name="default" />

        <template v-if="!$slots.default">
          {{ $t('UploadMainHint1') }} {{ accept || acceptList.join(' ') || '' }} {{ $t('UploadMainHint2') }}
          {{ limitSize / 1024 }}Mb
        </template>
      </div>
    </el-upload>
    <div
      v-if="result.success || result.error || result.total || result.message"
      class="upload-result"
    >
      <p>
        <span v-if="result.success">{{ $t('UploadSuccessText') }}：{{ result.success }}</span>
        <span v-if="result.error">{{ $t('UploadFailText') }}：{{ result.error }}</span>
        <span v-if="result.total">{{ $t('UploadTotalText') }}：{{ result.total }}</span>
      </p>
      <p v-if="result.message">{{ result.message }}</p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'BjImportFile',
  props: {
    limitSize: {
      type: Number,
      default: 2048,
    },
    autoUpload: {
      type: Boolean,
      default: false,
    },
    limit: {
      type: Number,
      default: 1,
    },
    // file input的原生属性：https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/file#accept
    accept: {
      type: String,
      default: '',
    },
    // 自定义类型检查. 只用文件名后缀
    acceptList: {
      type: Array,
      default: function() {
        return [];
      },
    },
    beforeUpload: Function,
  },
  data() {
    return {
      fileList: [],
      result: {
        success: 0,
        error: 0,
        total: 0,
        message: '',
        url: '',
      },
    };
  },
  methods: {
    setResult(d) {
      this.result = { ...this.result, ...d };
    },
    bjBeforeUpload(file) {
      if (typeof this.beforeUpload === 'function') {
        return this.beforeUpload(file);
      }

      let TYPE_FLAG = true;
      let SIZE_FLAG = true;
      if (this.acceptList.length) {
        const TYPE_FLAG_1 = this.acceptList.includes(file.type);
        const TYPE_FLAG_2 = this.acceptList.some(t => {
          return file.name.endsWith(t);
        });
        TYPE_FLAG = TYPE_FLAG_1 || TYPE_FLAG_2;
        if (!TYPE_FLAG) {
          this.$message.error(
            `${this.$t('UploadFormatText1')} ${this.acceptList.join(' / ')} ${this.$t('UploadFormatText2')}${file.type}!`,
          );
          return false;
        }
      }

      if (this.limitSize) {
        SIZE_FLAG = file.size / 1024 < this.limitSize;
        if (!SIZE_FLAG) {
          this.$message.error(`${this.$t('UploadMsgError')} ${this.limitSize} KB!`);
          return false;
        }
      }
      return TYPE_FLAG && SIZE_FLAG;
    },
    httpRequest() {
      if (this.autoUpload) {
        this.importFile();
      }
    },
    handleChange(file, fileList) {
      this.fileList = fileList.slice(this.limit * -1);
    },
    handleRemove(file, fileList) {
      this.fileList = fileList;
    },
    handleSuccess(response, file, fileList) {
      this.fileList = fileList;
    },
    handlePropress(event, file, fileList) {
      this.fileList = fileList;
    },
    importFile() {
      this.$emit('importFile', this.fileList[0].raw);
    },
  },
};
</script>
<style>
.upload-demo-20210810 {
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.upload-demo-20210810 .upload-result {
  padding: 0 1.25rem;
  border: 1px solid rgba(0, 0, 0, 0.125);
  margin-top: 8px;
}
.upload-demo-20210810 .upload-result > p > span {
  margin-right: 16px;
}
</style>
